//export const API_BASE_URL = 'http://localhost:9000';
export const API_BASE_URL = 'https://hr.apivcm.shop';

